'use client';
import { useEffect } from 'react';
import { spmTrackingUtils } from '@/intl-jdi-common-ssr/utils/spmTrackUtils';
import { JSBridge } from '@/utils/bridge';
import clientApp from '@/utils/client.app';

interface PVParam {
  spm: string;
  page_id: string;
  page_param?: object;
}

export default function PvModule(params: PVParam) {
  const isInApp = clientApp.inApp;

  function getAppMtaParams() {
    return new Promise((resolve, reject) => {
      const setMtaParams = (payload: any) => {
        if (payload) {
          resolve(payload);
        } else {
          reject(new Error('fetch app mta error'));
        }
      };
      JSBridge.functionInApp({
        method: 'getMtaParams',
        callbackFn: setMtaParams,
      });
    });
  }

  useEffect(() => {
    params?.spm &&
      params?.page_id &&
      spmTrackingUtils.spmPV({
        ...params,
        inApp: isInApp,
        getAppMtaParams: isInApp ? getAppMtaParams : undefined,
      });
  }, [params.page_id, params.spm]);
  return null;
}
